/* tslint:disable */
/* eslint-disable */
/**
 * Account Settings API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdatePhoneRequest
 */
export interface UpdatePhoneRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdatePhoneRequest
     */
    authenticationToken?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePhoneRequest
     */
    number: string;
}

/**
 * Check if a given object implements the UpdatePhoneRequest interface.
 */
export function instanceOfUpdatePhoneRequest(value: object): value is UpdatePhoneRequest {
    if (!('number' in value) || value['number'] === undefined) return false;
    return true;
}

export function UpdatePhoneRequestFromJSON(json: any): UpdatePhoneRequest {
    return UpdatePhoneRequestFromJSONTyped(json, false);
}

export function UpdatePhoneRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePhoneRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'authenticationToken': json['authenticationToken'] == null ? undefined : json['authenticationToken'],
        'number': json['number'],
    };
}

export function UpdatePhoneRequestToJSON(value?: UpdatePhoneRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'authenticationToken': value['authenticationToken'],
        'number': value['number'],
    };
}

